import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";

import {EmployerComponent} from "./list.component";
import {EmployerRegistrationComponent} from "./registration.component";

// Chart.js Angular 2 Directive by Valor Software (npm)
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { FlotModule } from '../../components/charts/flotChart';
import { IboxtoolsModule } from '../../components/common/iboxtools/iboxtools.module';
import { PeityModule } from '../../components/charts/peity';
import { SparklineModule } from '../../components/charts/sparkline';
import { JVectorMapModule } from '../../components/map/jvectorMap';


@NgModule({
  declarations: [EmployerComponent,EmployerRegistrationComponent],
  imports     : [ChartsModule, FlotModule,IboxtoolsModule,PeityModule,SparklineModule,JVectorMapModule],
  exports     : [EmployerComponent,EmployerRegistrationComponent],
})

export class EmployerModule {}



// WEBPACK FOOTER //
// ./src/app/views/employer/employer.module.ts